// Records where the time goes on each automatic apply, so a slow signature can
// be diagnosed from the task pane instead of guessed at. Stored in
// OfficeRuntime.storage, which the event runtime and the task pane share.
const KEY = "thf.lastApplyTiming";
function describeClient() {
    try {
        const d = Office.context.diagnostics;
        return [d?.host, d?.platform, d?.version].filter(Boolean).join(" ");
    }
    catch {
        return undefined;
    }
}
export function startTiming(event) {
    const t0 = Date.now();
    const steps = {};
    const origin = typeof performance !== "undefined" ? performance.timeOrigin : 0;
    const bootMs = origin ? Math.max(0, Math.round(t0 - origin)) : undefined;
    return {
        /** Runs `fn` and records how long it took under `name`, on failure too
         *  (as "name (failed)"), so a slow rejected step is never blamed on the
         *  next one. Use a distinct name per attempt. */
        async time(name, fn) {
            const start = Date.now();
            try {
                const r = await fn();
                steps[name] = Date.now() - start;
                return r;
            }
            catch (err) {
                steps[`${name} (failed)`] = Date.now() - start;
                throw err;
            }
        },
        async finish(path) {
            // totalMs ends here, before the awaited save below: the cost of saving
            // this readout is not in it (see formatTiming's label).
            const t = {
                event,
                path,
                at: t0,
                bootMs,
                totalMs: Date.now() - t0,
                steps,
                client: describeClient(),
            };
            try {
                await OfficeRuntime.storage.setItem(KEY, JSON.stringify(t));
            }
            catch {
                // diagnostics only — never let this affect the signature
            }
        },
    };
}
export async function loadTiming() {
    try {
        const raw = await OfficeRuntime.storage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
export function formatTiming(t) {
    const time = new Date(t.at).toLocaleTimeString("en-GB");
    const steps = Object.entries(t.steps)
        .map(([k, v]) => `${k} ${v}`)
        .join(", ");
    const boot = t.bootMs !== undefined ? ` · Outlook started the add-in ${t.bootMs} ms before our code ran` : "";
    return `Last auto-apply ${time} (${t.event}, ${t.path}): our code ${t.totalMs} ms, before saving this readout [${steps}]${boot}${t.client ? ` · ${t.client}` : ""}`;
}
